export default {
  api: {
    list: {
      method: "get",
      url: "/user/bill/list"
    }
  }
};
